import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { ArrowRightLeft } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const DataMapperNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'Data Mapper'}
        icon={ArrowRightLeft}
        colorClass="from-green-500 to-green-700"
        bgClass="bg-gradient-to-br from-green-500 to-green-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={false}
        isTarget={true}
        rowsProcessed={data?.rowsAffected}
    />
));
DataMapperNode.displayName = 'DataMapperNode';
export default DataMapperNode;
